import { nodesFlux } from '@candulabs/craft';
import { connectWithHammock, ENDPOINTS } from 'hammock';
import React, { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router';

import { ContentMetadata, ContentSlug, ContentType } from '@candu-ai/content/types';
import { ContentEmbed } from 'craft/components/Embed';
import Node from 'craft/components/Node';
// TODO import this from better place
import { useEditorNode, useEditorSelector, useNodeContext } from 'craft/hooks';
import { Resolver, ToolboxComponentSections } from 'craft/types';

interface Props {
  slug?: ContentSlug;
  contentList: ContentMetadata[];
  // Old prop coming from EmbedTutorial TODO: remove it later
  id?: number;
}

const UnconnectedEmbedContent: Resolver<Props> = ({ slug, contentList }: Props) => {
  const { pathname } = useLocation();
  const { id } = useNodeContext();
  const { setCustom } = useEditorNode(id);
  const customSelector = useMemo(() => nodesFlux.selectors.getNodeCustom(id), [id]);
  const custom = useEditorSelector(customSelector) ?? {};

  useEffect(() => {
    if (custom.css?.alignItems === 'center') {
      // TODO: 2021-10-22: remove it later
      // For some reason, lots of our portals have align-items set center,
      // which creates issues. Reset it back to normal.
      setCustom({ ...custom, css: { ...custom.css, alignItems: 'normal' } });
    }
  }, [custom.css?.alignItems]);

  return (
    <Node>
      <ContentEmbed
        contentList={contentList.filter(
          (content) => content.id !== pathname.match(/\/editor\/(.*)\/content\//)?.[1],
        )}
        slug={slug}
      />
    </Node>
  );
};

export const EmbedContent = connectWithHammock({
  endpoint: ENDPOINTS.contentMetadata,
  // Make sure hammock doesn't get the id from props.
  id: undefined,
  query: { finder: 'byContentType', contentType: ContentType.Inline },
  resourceName: 'contentList',
})(UnconnectedEmbedContent);

// @ts-expect-error
EmbedContent.craft = {
  displayName: 'Embed',
  name: 'EmbedPortal',
};

// @ts-expect-error
EmbedContent.toolbox = {
  schema: {
    [ToolboxComponentSections.Layout]: {
      blockedDisplays: ['flex', 'inline-block'],
    },
  },
};
